import { useState } from 'react';

export interface IPropertyContact {
  id: string;
  firstname: string;
  lastname: string;
  email: string;
  profileImage: string | null;
  username: string | null;
  address: string | null;
  phone: string | null;
  contactType: string | null;
  isPrimaryContact: boolean;
  status: string | null;
  allowEmail: boolean;
  signature: string | null;
  signType: string | null;
  isSpark: boolean;
  role: string | null;
  designated: boolean;
  signedOn: string;
  createdOn: string;
  lastLoggedOn: string | null;
}

export interface IModulePermission {
  Id: string;
}

export interface IPropertyFormData {
  id?: string;
  propertyId?: string;
  name: string;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  province: string;
  postalCode: string;
  latitude?: string;
  longitude?: string;
  image?: string;

  selectedImage?: any;
  propertyManagerId: string;
  strataManagerId?: string | null;
  propertyManager?: IPropertyContact | null;
  strataManager?: IPropertyContact | null;
  primaryContact?: IPropertyContact | null;
  constructionStages?: any[] | null;
  customStages?: any[] | null;
  modulePermissions?: IModulePermission[] | null;
  isSpark?: boolean;
  sparkSyncSuspended?: boolean;
  syncAutomationSuspended?: boolean;

  selectedStage?: string;
  selectedStatus?: string;
  selectedDate?: string;
  customStageName?: string;
  isCustomStageEnabled?: boolean;

  [key: string]: any;
}

const EMPTY_FORM_SHAPE: IPropertyFormData = {
  name: '',
  addressLine1: '',
  city: '',
  province: '',
  postalCode: '',
  propertyManagerId: '',
};

export interface UsePropertyFormDataReturn {
  propertyFormData: IPropertyFormData;
  selectedModulePermissions: IModulePermission[];
  setFormData: (data: Partial<IPropertyFormData>) => void;
  clearFormData: () => void;
  setSelectedModulePermissions: (perms: IModulePermission[]) => void;
}

export const usePropertyFormState = (
  initialData: IPropertyFormData | null | undefined,
  initialModulePermissions: IModulePermission[] | null | undefined
): UsePropertyFormDataReturn => {
  const [propertyFormData, setPropertyFormDataState] =
    useState<IPropertyFormData>(initialData ?? EMPTY_FORM_SHAPE);

  const [selectedModulePermissions, setSelectedModulePermissionsState] =
    useState<IModulePermission[]>(initialModulePermissions ?? []);

  const setFormData = (data: Partial<IPropertyFormData>): void => {
    setPropertyFormDataState((previous: IPropertyFormData) => ({
      ...previous,
      ...data,
    }));
  };

  const clearFormData = (): void => {
    setPropertyFormDataState({ ...EMPTY_FORM_SHAPE });
  };

  const setSelectedModulePermissions = (perms: IModulePermission[]): void => {
    setSelectedModulePermissionsState(perms);
  };

  return {
    propertyFormData,
    selectedModulePermissions,
    setFormData,
    clearFormData,
    setSelectedModulePermissions,
  };
};
